import * as React from "react"
import Svg, { Path } from "react-native-svg"

const GiftIconOpen = (props) => {
  return (
    <Svg
      width={19}
      height={21}
      viewBox="0 0 19 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M15.5 12.188v7.5c0 .72-.592 1.312-1.313 1.312H8.564v-8.25H7.437V21H1.813C1.093 21 .5 20.407.5 19.687v-7.5c0-.307.255-.562.563-.562h13.874c.308 0 .563.255.563.563z"
        fill="#D32F2F"
      />
      <Path
        d="M18.212 10.641l-.486 1.812a1.319 1.319 0 01-1.607.928L1.268 9.4A1.319 1.319 0 01.34 7.794l.485-1.811a1.319 1.319 0 011.607-.928l14.851 3.979c.696.186 1.115.912.928 1.607z"
        fill="#F44336"
      />
      <Path
        d="M9.655 7.8a.564.564 0 01-.37-.767c.753-1.74 3.086-4.786 6.525-3.864 1.963.526 2.376 1.773 2.132 2.682-.433 1.614-3.29 3.288-8.287 1.949zm5.864-3.544c-2.595-.696-4.241 1.507-4.89 2.623 2.073.453 3.502.28 4.364.039 1.195-.336 1.746-.922 1.863-1.36.174-.65-.576-1.099-1.337-1.302z"
        fill="#FFC107"
      />
      <Path d="M8.563 12.75V21H7.437v-8.25h1.125z" fill="#FF8F00" />
      <Path
        d="M10.287 7.618l-1.05 3.92-1.087-.292L9.2 7.327a.68.68 0 01.267-.386.558.558 0 01.44-.077c.152.041.27.15.342.286a.677.677 0 01.038.468z"
        fill="#FFC107"
      />
      <Path
        d="M7.438 12.75H.5v6.938c0 .72.593 1.312 1.313 1.312h5.625v-8.25z"
        fill="#B82929"
      />
      <Path
        d="M5.487 5.873l-3.055-.818a1.319 1.319 0 00-1.607.928L.34 7.793a1.319 1.319 0 00.928 1.608l.18.049 6.702 1.795.964-3.6c-1.544-.47-2.74-1.094-3.627-1.772z"
        fill="#D43A2F"
      />
      <Path
        d="M6.35 1.8c-.76-.203-1.635-.19-1.81.461-.247.925.92 3.044 4.733 4.257-.004-1.292-.328-4.022-2.922-4.717z"
        fill="#DEDEDE"
      />
      <Path
        d="M9.273 6.516c-3.814-1.212-4.98-3.33-4.733-4.257.175-.65 1.05-.664 1.81-.46 2.595.696 2.92 3.426 2.923 4.717zM6.643.713C4.678.187 3.697 1.06 3.453 1.969c-.276 1.03.29 2.573 2.033 3.904.889.678 2.083 1.3 3.628 1.772l.085-.32a.68.68 0 01.267-.386.558.558 0 01.44-.076l.41-1.532C10.047 3.486 9.09 1.369 6.642.713z"
        fill="#DEA806"
      />
      <Path d="M8 12.75h-.563V21H8v-8.25z" fill="#DE7C00" />
      <Path
        d="M9.907 6.864a.558.558 0 00-.44.077.677.677 0 00-.267.386l-.085.32-.965 3.6.543.145 1.214-4.528z"
        fill="#DEA806"
      />
    </Svg>
  )
}

export default GiftIconOpen
